import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageWrapper } from '@src/components';
import { CountryView } from './components/CountryView';
import { RegionView } from './components/RegionView';
import { useTranslation } from 'react-i18next';

export type StoreTab = 'country' | 'region';

export function Store() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') as StoreTab | null;

  const [activeTab, setActiveTab] = useState<StoreTab>('country');
  const tabOptions: StoreTab[] = ['country', 'region'];

  useEffect(() => {
    if (tabOptions.includes(tabParam as StoreTab)) {
      setActiveTab(tabParam as StoreTab);
    } else {
      setSearchParams({ tab: 'country' });
    }
  }, [tabParam, setSearchParams]);

  const handleTabChange = (key: StoreTab | null) => {
    if (!key) return;
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  return (
    <PageWrapper title={t('pages.store.title')}>
      {activeTab === 'country' ? (
        <CountryView
          onTabChange={(value: StoreTab) => handleTabChange(value)}
        />
      ) : (
        <RegionView onTabChange={(value: StoreTab) => handleTabChange(value)} />
      )}
    </PageWrapper>
  );
}
